<!-- Loader -->
<ng-template #loading>
  <terra-loader class="loader" />
</ng-template>

<div *ngIf="unitBankAccount$ | async as account; else loading" class="page-container">
  <!-- When the bank account is not yet approved -->
   @if(account.status === UnitDepositAccountStatus.None){
    <terra-unit-bank-account-pending-approval [bankAccount]="account" [userShouldApprove]="isUserShouldApprove$ | async" />
  }

  <!-- When the bank account is Open/closed -->
  @if(isActiveStatus(account.status)){
    <terra-bank-account [account]="bankAccount$ | async"
    [unitParentType]="account.unitApplication?.parentType"
    [status]="account.status"
    [accountLimits]="account.accountLimits"
    [pendingBalance]="account.pendingBalance"
    [bankAccountType]="BankAccountProvider.UnitAccount"
    [refreshCards$]="refreshCards$"
    [remarkNote]="(accountProvider$ | async) === UnitAccountProvider.Thread ? 'Thread Financial Group' : 'Choice Financial Group'"
    [statusNamespace]="UnitDepositAccountStatus"
    [shouldShowCashSweepingDescription]="(accountProvider$ | async) === UnitAccountProvider.Thread" />
  }
</div>

<terra-unit-bank-sticky-footer [bankingProviderString]="bankingProviderString$ | async" [accountProvider]="accountProvider$ | async" />
